import React, { useState } from 'react';
import { Typography, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useDatePickerStyles } from './DatePickerStyles';

const Policy = () => {
  const { styles, dayButtonClass } = useDatePickerStyles();
  return (
    <Box
      sx={{ width: '100%', maxWidth: 1600, maxHeight: 800, overflowX: 'auto', ...styles.scrollbar }}
    >
      <div>
        <h2>УСЛОВИЯ ВОЗВРАТА ДЕНЕЖНЫХ СРЕДСТВ </h2>
        <p>
          1. Денежные средства (либо часть денежных средств) при оказании Услуг возвращаются Клиенту
          в случаях, когда оплаченная им Услуга остается по следующим причинам нереализованной, а
          именно:
        </p>
        <p>- невыполнение обязательств допущено по вине Спортивного клуба;</p>
        <p>- выполнена услуга ненадлежащего качества.</p>
        <p> 2. Возврат денежных средств Клиенту не осуществляется в следующих случаях:</p>
        <p>- при наступлении форс-мажорных обстоятельств;</p>
        <p>
          - при невозможности исполнения услуги, возникшей по вине Спортивного клуба согласно ст.
          781.3 Гражданского кодекса Российской Федерации;
        </p>
        <p>
          - при иных обстоятельствах, предусмотренных Гражданским кодексом Российской Федерации,
          Законом Российской Федерации от 07.02.1992 №2300-1 &laquo;О защите прав
          потребителей&raquo;.
        </p>
        <p>
          3. Клиент, оплативший Услугу, вправе вернуть деньги за Услугу или отказаться от
          бронирования. Возврат денежных средств в полном объеме за оплату Услуг осуществляется
          путем перечисления денежных средств в профиль Клиента на его баланс за исключением
          случаев, оговоренных в п. 5.
        </p>
        <p>
          4. Возврат денежных средств, оплаченных Клиентом для посещения Спортивного клуба, в полном
          объеме осуществляется в том случае, если Клиент отменил бронирование на веб-сайте не менее
          чем за 12 часов до начала самого бронирования.
        </p>
        <p>
          Для этого необходимо не менее чем за 12 часов отменить бронирование на веб-сайте,
          подтвердив свое действие. В этом случае вся неиспользованная сумма автоматически
          возвращается Клиенту в его личный профиль. В случае отмены бронирования менее чем за 12
          часов Услуга считается оказанной и денежные средства возврату не подлежат.
        </p>
        <p>
          5. В том случае, если Клиент желает возврата денежных средств на расчетный счет, с
          которого он перечислил денежные средства в счет оплаты Услуг, Клиент обязан в письменной
          форме направить заявление на возврат денежных средств в Службу поддержки Спортивного клуба
          с указанием следующих данных:
        </p>
        <p>- заявление на возврат денежных средств в письменной форме;</p>
        <p>- платежные документы (чек об оплате);</p>
        <p>- полное наименование Клиента, включая ФИО, ИНН;</p>
        <p>- банковские реквизиты (номер расчетного счета, БИК, наименование банка).</p>
        <p>
          <p>
            6. При необходимости сотрудники Спортивного клуба могут потребовать у Клиента
            дополнительные документы.
          </p>
          <p>
            7. Денежные средства за неоказанные услуги возвращаются Клиенту в течение 10 (десяти)
            рабочих дней с момента предоставления данных и документов, оговоренных в п. 5, согласно
            ст. 31 Закона Российской Федерации от 07.02.1992 №2300-1 &laquo;О защите прав
            потребителей&raquo;.
          </p>
          <p>
            8. Возврат денежных средств Клиенту производится при условии оплаты Спортивному клубу
            фактически понесенных им расходов.
          </p>
        </p>
      </div>
    </Box>
  );
};
export default Policy;
